import * as React from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  CardActionArea,
  styled,
  useTheme,
} from '@mui/material';
import {StyledTooltip} from 'components/StyledTooltip/StyledTooltip';
import {RACI_ClassNames} from 'app/types/Shared';

//Styled Accordian remove padding so children take up full width
const AccordionDetailsStyled = styled(AccordionDetails)(({theme}) => ({
  padding: theme.spacing(0),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

//Props for filter component
type RACIClassFiltersProps = {
  title: string; //class name
  size: number; //how many roles
  lookup: string; //abbreviated Class Name
  callback2: (arg0: string, arg1: string) => void; //Set Filters
  FilterDictionary: {[key: string]: Array<filter>}; //Dictonary of all Roles
  callback: () => void; //set toggle if filters change
};

type filter = {
  roleAbbr: string;
  roleName: string;
  selected: boolean;
};

const RACIRoleFilters = (props: RACIClassFiltersProps) => {
  const theme = useTheme();
  const [clicked, setClicked] = React.useState(false);
  const HandleClick = (type: string, lookup: string) => {
    props.callback2(type, lookup);
    if (clicked) setClicked(false);
    else setClicked(true);
    props.callback();
  };

  const hasSelected = () => {
    let flag = false;
    Object.keys(props.FilterDictionary).forEach((obj) => {
      if (props.FilterDictionary[obj].some((x) => x.selected === true)) {
        flag = true;
      }
    });
    return flag;
  };

  //Change color of filter buttons if selected or not
  const setBTNColor = (type: string, lookup: string) => {
    const index = props.FilterDictionary[lookup].findIndex((item) => item.roleAbbr === type);
    if (index >= 0) {
      if (props.FilterDictionary[lookup].at(index)?.selected) return true;
      else return false;
    }
  };

  const FilterDictionaryTotalLength =
    props.FilterDictionary[RACI_ClassNames.CRO]?.length +
    props.FilterDictionary[RACI_ClassNames.TAK]?.length +
    props.FilterDictionary[RACI_ClassNames.oTAK]?.length;

  return (
    <Box display='flex' alignItems='flex-end' sx={{height: 58, marginTop: '20px'}}>
      <Accordion disableGutters elevation={0} sx={{width: '100%'}} expanded={true}>
        <AccordionSummary
          sx={{
            bgcolor: 'grey.800',
            minHeight: 35,
            maxHeight: 35,
          }}
          id={props.title}
        >
          <Typography variant='h5' color='white'>
            {props.size > 1 || FilterDictionaryTotalLength < 12 ? props.title : props.title.substring(0, 4)}
          </Typography>
        </AccordionSummary>
        <AccordionDetailsStyled>
          <Grid container columns={props.size} direction='row' border={`1px solid ${theme.palette.grey[500]}`}>
            {props.lookup &&
              props.FilterDictionary[props.lookup].map((i, index) => (
                <Grid item key={`-${i.roleName}-${props.title}`} xs={1}>
                  <StyledTooltip
                    title={
                      <Typography variant='h3' m={1}>
                        {i.roleName}
                      </Typography>
                    }
                    arrow
                  >
                    <CardActionArea onClick={() => HandleClick(i.roleAbbr, props.lookup)}>
                      <Box
                        width='100%'
                        textAlign='center'
                        alignItems='center'
                        justifyContent='center'
                        display='flex'
                        height={35}
                        sx={{
                          borderLeft: index !== 0 ? '1px solid' : 'none',
                          borderColor: 'grey.500',
                        }}
                        bgcolor={theme.palette.grey[100]}
                      >
                        <Typography
                          color={
                            hasSelected()
                              ? setBTNColor(i.roleAbbr, props.lookup)
                                ? 'primary'
                                : 'rgba(0, 0, 0, 0.35)'
                              : 'black'
                          }
                          variant='h4'
                          fontSize={i.roleAbbr?.length > 5 ? 13 : 14}
                        >
                          {i.roleAbbr}
                        </Typography>
                      </Box>
                    </CardActionArea>
                  </StyledTooltip>
                </Grid>
              ))}
          </Grid>
        </AccordionDetailsStyled>
      </Accordion>
    </Box>
  );
};

export default RACIRoleFilters;
